// Image fallback handler specifically for network logos on /reseau page
export default function initImageFallback() {
  // Only apply on network pages
  if (!window.location.pathname.includes('/reseau')) {
    return;
  }

  // Function to handle image errors for network logos only
  function handleImageError(img) {
    // Only handle images that are likely network logos
    if (
      !img.src.includes('imagekit.io') ||
      !img.src.includes('udb-production')
    ) {
      return;
    }

    // Prevent infinite loop
    if (img.dataset.fallbackApplied) return;
    img.dataset.fallbackApplied = 'true';

    // Extract network name from alt text
    const networkName = img.alt.replace(/logo\s*/i, '').trim();

    // Create placeholder
    const placeholder = document.createElement('div');
    placeholder.className = `${
      img.className
    } bg-gray-200 flex items-center justify-center rounded-sm text-2xl font-bold text-gray-600`;
    placeholder.style.width = img.width ? `${img.width}px` : '64px';
    placeholder.style.height = img.height ? `${img.height}px` : '64px';
    placeholder.textContent = networkName.charAt(0).toUpperCase();
    placeholder.title = networkName;

    // Replace image with placeholder
    img.parentNode.replaceChild(placeholder, img);
  }

  // Apply only to network logo images
  function checkImages() {
    // More specific selector for network logos
    const networkImages = document.querySelectorAll(
      'img[src*="imagekit.io"][src*="udb-production"]',
    );

    networkImages.forEach(img => {
      // Check if already loaded with error
      if (img.complete && img.naturalHeight === 0) {
        handleImageError(img);
      } else {
        // Add error handler for future errors
        img.addEventListener(
          'error',
          function () {
            handleImageError(this);
          },
          { once: true },
        );
      }
    });
  }

  // Run immediately
  checkImages();

  // Also run after DOM is loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkImages);
  }
}
